



















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import { AttributesHelper } from "../../lib/utils/AttributesHelper";

/**
 * The *anx-checkbox* renders a simple checkbox.
 * It works like a default HTML checkbox, but has some features implemented.
 * The layout of the checkbox also differs from a default checkbox.
 */
@Component({
  components: {
    ValidationProvider
  }
})
export default class AnxCheckbox extends Vue {
  /** This is the id for the checkbox */
  @Prop({ default: null }) id!: string | null;
  /** This is the name of the input with type checkbox. This will be used as label for the checkbox */
  @Prop({ default: "" }) name!: string;
  /** If the validation property is set, a ValidationProvider with "required" validation will be added */
  @Prop({ default: null }) validation!: boolean | null;
  /** This is the property, that can be used via v-model. The @input event will automatically be emitted on change */
  @Prop({}) value!: boolean;

  /** The id that is actually used */
  private inputId: string | undefined = "";

  /** Watch, if the value in the parent changes */
  @Watch("value")
  onValueChanged(newVal: boolean) {
    this.valueModel = newVal;
  }

  /** Use a seperate variable for v-model in the AnxCheckbox component to avoid mutating the parent property directly */
  private valueModel = false;

  /**
   * Set the id for the component when created
   */
  private created() {
    this.inputId = AttributesHelper.attributes(this, {
      uniqueId: true,
      uniqueIdPrefix: "anx-input-"
    }).id;
  }

  /** Assign the value to the variable we use for v-model */
  private beforeMount() {
    this.valueModel = this.value;
  }
}
